import React, { FC, ReactNode } from 'react';
import { Col, Layout, Row } from 'antd';
import { SidebarMob } from 'common/components/Sidebar/SidebarMob';

const { Header } = Layout;

interface IComponentProps {
  title: ReactNode;
  extra?: ReactNode;
}

export const PageHeaderMob: FC<IComponentProps> = ({ title, extra }) => {
  return (
    <Header className="page-header-mob">
      <Row wrap={false} justify="space-between">
        <Col>
          <div className="page-header-mob__title">{title}</div>
        </Col>
        <Col>
          <Row gutter={8}>
            <Col>{extra}</Col>
            <Col>
              <SidebarMob />
            </Col>
          </Row>
        </Col>
      </Row>
    </Header>
  );
};
